import { Component } from '@angular/core';

/**
 * User Architecture content for Clinical AI Studio.
 *
 * Content-only placeholder — projected into the shared shell by
 * {@link Docs2Component} when the User Architecture card is selected. The
 * architecture material will be added here later; its section ids are listed in
 * `ARCH_GROUPS` (see docs-groups.ts).
 */
@Component({
  selector: 'app-docs-architecture',
  standalone: true,
  imports: [],
  templateUrl: './docs-architecture.component.html',
  styleUrl: './docs-architecture.component.css',
})
export class DocsArchitectureComponent {}
